/* eslint-disable no-restricted-imports */
import { ethers } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { FaEthereum } from 'react-icons/fa';
import { LIDO_STETH_TOKEN } from '../constants';
export var Deposit = createPlugin({
    protocol: 'LIDO',
    type: 'ACTION',
    method: 'submit',
    supportedContracts: LIDO_STETH_TOKEN,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            value: new FctValue({ isPreview: true, icon: FaEthereum }),
            methodParams: {
                referral: new FctAddress({ required: false, isPreview: true, icon: FaEthereum }),
            },
        },
        output: {},
    }); },
    initParams: {
        methodParams: {
            referral: ethers.constants.AddressZero,
        },
    },
});
